"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var Link = function Link(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), (0, _preact.h)("path", {
    d: "M9.98758 10.9814L8 12.9689C7.31263 13.6563 6.48447 14 5.51553 14C4.54658 14 3.71843 13.6563 3.03106 12.9689C2.34369 12.2816 2 11.4534 2 10.4845C2 9.51553 2.34369 8.68737 3.03106 8L5.01863 6.01242L6.01242 7.00621L4.02484 8.99379C3.61077 9.40787 3.40373 9.90476 3.40373 10.4845C3.40373 11.0642 3.61077 11.5611 4.02484 11.9752C4.43892 12.3892 4.93582 12.5963 5.51553 12.5963C6.09524 12.5963 6.59213 12.3892 7.00621 11.9752L8.99379 9.98758L9.98758 10.9814ZM6.50932 10.4845L5.51553 9.49068L9.49068 5.51553L10.4845 6.50932L6.50932 10.4845ZM10.9814 9.98758L9.98758 8.99379L11.9752 7.00621C12.3892 6.59213 12.5963 6.09524 12.5963 5.51553C12.5963 4.93582 12.3892 4.43892 11.9752 4.02484C11.5611 3.61077 11.0642 3.40373 10.4845 3.40373C9.90476 3.40373 9.40787 3.61077 8.99379 4.02484L7.00621 6.01242L6.01242 5.01863L8 3.03106C8.68737 2.34369 9.51553 2 10.4845 2C11.4534 2 12.2816 2.34369 12.9689 3.03106C13.6563 3.71843 14 4.54658 14 5.51553C14 6.48447 13.6563 7.31263 12.9689 8L10.9814 9.98758Z",
    fill: "#currentColor"
  }));
};

var _default = Link;
exports.default = _default;